import map from 'lodash/map'
import { useMemo } from 'react'
import { Highlight, Snippet } from 'react-instantsearch-dom'
import { useSearchHits } from '../SearchHitsContext'

export const useLexiconSearchHitsAsArticles = () => {
  const hits = useSearchHits()
  const articles = useMemo(() => {
    return map(hits, (hit) => {
      const matchedTitle = hit._highlightResult.title.matchLevel !== 'none'
      const matchedPreviewText =
        hit._highlightResult.previewText.matchLevel !== 'none'
      const matchedFullText =
        hit._highlightResult.fullText.matchLevel !== 'none'
      const showFullTextSnippet =
        !matchedTitle && !matchedPreviewText && matchedFullText

      // return <SimpleJson value={props} />
      const previewTextHighlight = (
        <Highlight hit={hit} attribute="previewText" tagName="mark" />
      )
      const titleHighlight = (
        <Highlight hit={hit} attribute="title" tagName="mark" />
      )
      const fullTextSnippet = (
        <>
          ...{' '}
          <Snippet
            hit={hit}
            attribute="fullText"
            highlightProperty="_snippetResult"
            tagName="mark"
          />
          ...{' '}
        </>
      )

      const previewText = showFullTextSnippet
        ? fullTextSnippet
        : previewTextHighlight
      return { ...hit, previewText, title: titleHighlight }
    })
  }, [hits])

  return articles
}
